import { IAddress } from '@checkout/state';

class Address implements IAddress {
  constructor(
    public email: string,
    public phoneNumber: string,
    public firstName: string,
    public lastName: string,
    public address1: string,
    public address2: string,
    public houseNumber: string,
    public zipCode: string,
    public company: string,
    public city: string,
    public state: string,
    public country: string,
    public newsletter: boolean | undefined,
  ) {}

  static create(address: IAddress): IAddress {
    return {
      email: address.email,
      phoneNumber: address.phoneNumber,
      firstName: address.firstName,
      lastName: address.lastName,
      address1: address.address1,
      address2: address.address2,
      houseNumber: address.houseNumber,
      zipCode: address.zipCode,
      company: address.company,
      city: address.city,
      state: address.state,
      country: address.country,
      newsletter: address.newsletter,
    };
  }
}

export default Address;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Address.ts